import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { Select } from 'primeng/select';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DatePicker } from 'primeng/datepicker';
import { AuthService } from '@core/service/auth.service';
import { dateRangeValidator } from '@core/validators/date-range.validator';
import { FileUploadModule } from 'primeng/fileupload';
import { MessageService } from 'primeng/api';
import { ApiService } from '@core/providers/http';
import { Toast } from 'primeng/toast';
import { EnumService } from '@app/features-modules/gestao-bolseiros/components/api/services';
import { RepresentacaoEmpresaService } from '@app/features-modules/bolsa-de-profissionais/services/representante-empresa.service';

@Component({
  selector: 'app-cadastrar-editar-representante',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DialogModule,
    Select,
    InputTextModule,
    ButtonModule,
    CheckboxModule,
    RadioButtonModule,
    FileUploadModule,
    DatePicker,
    Toast,
  ],
  providers: [AuthService, ApiService, RepresentacaoEmpresaService],
  template: `
    <div class="custom-modal-layout">
      <div class="modal-header" style="margin-bottom: 5px !important;">
        <div class="icon">
          <img src="icons/plus-circle.svg" alt="Email Icon" />
        </div>
        <span class="title">Editar representante</span>
        <p-button
          icon="pi pi-times"
          class="close-btn"
          [rounded]="true"
          [text]="true"
          (onClick)="cancel()"
        ></p-button>
      </div>

      <form
        [formGroup]="representanteForm"
        (ngSubmit)="save()"
        class="add-represent-form"
      >
        <div class="p-fluid grid">
          <div class="field col-12">
            <div class="file-upload">
              <p-fileupload
                name="myfile[]"
                (onSelect)="onSelectedFiles($event)"
                [multiple]="false"
                accept="image/png, image/jpeg, image/jpg"
                maxFileSize="2000000000"
                invalidFileTypeMessageSummary="danger"
                invalidFileTypeMessageDetail="O Ficheiro seleccionado é inválido"
                invalidFileLimitMessageSummary="danger"
                invalidFileLimitMessageDetail="Ficheiro muito grande. Min: 2MB"
              >
                <ng-template
                  #header
                  let-files
                  let-chooseCallback="chooseCallback"
                  let-clearCallback="clearCallback"
                  let-uploadCallback="uploadCallback"
                >
                </ng-template>
                <ng-template
                  #content
                  let-files
                  let-uploadedFiles="uploadedFiles"
                  let-removeFileCallback="removeFileCallback"
                  let-chooseCallback="chooseCallback"
                  let-removeUploadedFileCallback="removeUploadedFileCallback"
                >
                  <a
                    class="circular-upload preview"
                    [ngStyle]="{
                      'background-image': imagePreview
                        ? 'url(' + imagePreview + ')'
                        : 'none',
                    }"
                  >
                    <span *ngIf="!imagePreview">Foto</span>
                    <div class="icon" (click)="choose($event, chooseCallback)">
                      <img src="icons/camera-01.svg" alt="" />
                    </div>
                  </a>
                  <!-- <button pButton type="button" label="Guardar Foto" class="p-button-primary mt-2" (click)="savePhoto()"></button> -->
                </ng-template>
                <ng-template #file></ng-template>
                <ng-template #empty></ng-template>
              </p-fileupload>
            </div>
          </div>
          <div class="field col-6">
            <label for="nacinalidade"
              >Nacionalidade <span class="text-red-500">*</span></label
            >
            <p-select
              id="nacinalidade"
              [filter]="true"
              formControlName="NacionalidadeEnum"
              class="w-full"
              [options]="nacionalidades"
              optionLabel="designacao"
              optionValue="id"
              placeholder="Seleccione a nacionalidade"
            />
          </div>

          <div class="field col-6">
            <label for="bi">Número Bilhete de Identidade*</label>
            <div class="flex align-items-center relative">
              <input
                id="bi"
                type="search"
                class="w-full"
                pInputText
                formControlName="bi"
                placeholder="Informe o número do BI"
              />
              <button
                pButton
                type="button"
                icon="pi pi-search"
                class="search-btn"
                [disabled]="representanteForm.get('bi')?.invalid"
                (click)="searchDocumentNumber()"
                aria-label="Search"
              ></button>
            </div>
            <div
              *ngIf="
                representanteForm.get('bi')?.touched &&
                representanteForm.get('bi')?.invalid
              "
            >
              <small
                class="error-message"
                *ngIf="representanteForm.get('bi')?.errors?.['required']"
                >Número Bilhete de Identidade é obrigatório.</small
              >
            </div>
          </div>

          <div class="field col-6">
            <label for="nome">Nome <span class="text-red-500">*</span></label>
            <input
              id="nome"
              type="text"
              class="w-full"
              pInputText
              formControlName="nome"
              placeholder="Digite o nome"
            />
            <div
              *ngIf="
                representanteForm.get('nome')?.invalid &&
                representanteForm.get('nome')?.touched
              "
              class="error-message"
            >
              Nome é obrigatório
            </div>
          </div>

          <div class="field col-6 d-flex flex-column">
            <label for="telefone1"
              >Telefone <span class="text-red-500">*</span></label
            >
            <!-- <input id="contacto" type="text" class="w-full" pInputText formControlName="telefone" /> -->
            <input
              id="contacto"
              type="text"
              class="w-full"
              pInputText
              formControlName="telefone"
              placeholder="Digite o telefone"
            />
            <div
              *ngIf="
                representanteForm.get('telefone')?.invalid &&
                representanteForm.get('telefone')?.touched
              "
              class="error-message"
            >
              Telefone é obrigatório e deve conter apenas números
            </div>
          </div>

          <div class="field col-6">
            <label for="email">Email <span class="text-red-500">*</span></label>
            <input
              id="email"
              type="email"
              class="w-full"
              pInputText
              formControlName="emailRepresentante"
              placeholder="Digite o email"
            />
            <div
              *ngIf="
                representanteForm.get('emailRepresentante')?.invalid &&
                representanteForm.get('emailRepresentante')?.touched
              "
              class="error-message"
            >
              Email é obrigatório e deve ser válido
            </div>
          </div>

          <div class="field col-6">
            <label for="tipoRepresentacao">Tipo de representação</label>
            <p-select
              [filter]="true"
              appendTo="body"
              id="tipoRepresentacao"
              class="w-full"
              optionLabel="designacao"
              optionValue="id"
              [options]="tipoRepresentacaoOptions"
              placeholder="Seleccione o tipo de representação"
              formControlName="tipoRepresentacaoID"
            />
            <div
              *ngIf="
                representanteForm.get('tipoRepresentacaoID')?.invalid &&
                representanteForm.get('tipoRepresentacaoID')?.touched
              "
              class="error-message"
            >
              Tipo de representação é obrigatório
            </div>
          </div>
        </div>

        <div class="modal-footer" style="margin-top: -10px !important;">
          <button
            pButton
            type="button"
            label="Cancelar"
            class="p-button-outlined"
            (click)="cancel()"
          ></button>
          <button
            pButton
            type="submit"
            label="Editar Representante"
            class="p-button-primary"
          ></button>
        </div>
      </form>
    </div>
    <p-toast></p-toast>
  `,
  styles: `
    .field {
      position: relative;
    }

    .file-upload {
      margin: 26px 0;
      .circular-upload {
        width: 100px;
        height: 100px;
        background-color: #ebebef;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        cursor: pointer;

        span {
          color: var(--gray-2, #94949b);
          font-size: 15px;
          font-style: normal;
          font-weight: 700;
          line-height: 150%;
        }

        .icon {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background-color: white;
          padding: 8px;
          position: absolute;
          right: 0;
          bottom: 8px;
        }

        &.preview {
          width: 100px;
          height: 100px;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
        }
      }
    }

    ::ng-deep {
      .p-fileupload-advanced {
        border: none !important;
        border-radius: none !important;
        background: none !important;
        color: none !important;
      }

      .p-fileupload-header {
        display: none !important;
      }

      p-progressbar {
        display: none !important;
      }
    }

    .field input[type='number'] {
      width: 100%;
      padding-right: 40px; /* Espaço para o botão */
    }

    .field .search-btn {
      position: absolute;
      right: 1px;
      top: 50%;
      height: 40px;
      transform: translateY(-50%);
      border: none;
      cursor: pointer;
      padding: 0;
    }

    .field .search-btn .pi {
      font-size: 1.2em;
      color: #333; /* Cor do ícone */
    }
  `,
  standalone: true,
})
export class CadastrarEditarRepresentanteComponent
  implements OnInit, OnDestroy
{
  messageService = inject(MessageService);
  config = inject(DynamicDialogConfig);
  enumService = inject(EnumService);
  ref = inject(DynamicDialogRef);
  private fb = inject(FormBuilder);
  private authService = inject(AuthService);
  private representacaoEmpresa = inject(RepresentacaoEmpresaService);
  tipoRepresentacaoOptions: any[] = [];
  private subscriptions = new Subscription();
  isEditMode: boolean = false;

  file: any;
  imagePreview: string | ArrayBuffer | null = null; // To store image as Base64 URL
  selectedFile: File | null = null;
  fotoPreviewMap: { [id: number]: string | ArrayBuffer | null } = {};

  perfilRepresentanteEmpresa: any;

  nacionalidades: any[] = [
    {
      id: 1,
      designacao: 'Nacional',
    },
    {
      id: 2,
      designacao: 'Estrangeira',
    },
  ];

  representanteForm = this.fb.group({
    id: ['0'],
    NacionalidadeEnum: [null, Validators.required],
    bi: ['', Validators.required],
    nome: [{ value: '', disabled: true }, Validators.required],
    telefone: ['', Validators.required],
    emailRepresentante: ['', [Validators.required, Validators.email]],
    tipoRepresentacaoID: ['', Validators.required],
    ativo: [true],
    usernameRepresentante: [''],
    empresaID: [this.config.data.empresaID, Validators.required],
    Foto: [null as string | File | null],
  });

  constructor() {
    this.tipoRepresentacaoOptions = this.config.data.tipoRepresentacaoOptions;
  }

  ngOnInit() {
    if (this.config.data.representante) {
      this.perfilRepresentanteEmpresa = this.config.data.representante;
      console.log(this.perfilRepresentanteEmpresa);
      this.loadRepresentanteDetails(this.perfilRepresentanteEmpresa);
      this.isEditMode = true;
    }
  }

  get f() {
    return this.representanteForm.controls;
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  loadRepresentanteDetails(representante: any): void {
    this.representanteForm.patchValue({
      id: representante.id,
      nome: representante.nome,
      telefone: representante.telefone,
      bi: representante.bi,
      emailRepresentante: representante.emailRepresentante,
      tipoRepresentacaoID: representante.tipoRepresentacaoID,
      ativo: representante.ativo,
      NacionalidadeEnum: representante.nacionalidadeEnum,
      usernameRepresentante: representante.usernameRepresentante,
      empresaID: representante.empresaID,
      Foto: representante.Foto,
    });

    // Define o preview da imagem se houver URL da foto
    this.representacaoEmpresa
      .getPhotoRepresentanteIdGet(representante.id)
      .subscribe((response) => {
        if (!response) return;

        const file = new File([response], 'photo.jpg', {
          type: response.type,
        });
        this.selectedFile = file;

        const reader = new FileReader();
        reader.onload = () => {
          this.imagePreview = reader.result as string;
        };
        reader.readAsDataURL(file);

        this.representanteForm.patchValue({ Foto: file });
      });
  }

  loadNacionalidade() {
    this.enumService.getAllNacionalidadeEnum().subscribe((response) => {
      if (response?.data) {
        this.nacionalidades = Object.entries(response.data).map(
          ([key, value]) => ({
            id: Number(key),
            designacao: value,
          }),
        );
      }
    });
  }

  choose(event: any, callback: () => void) {
    callback();
  }

  onSelectedFiles(event: { currentFiles: any }) {
    this.file = event.currentFiles[0];

    //Adicionar validação de tamanho da imagem (ex: máx. 2MB)
    const maxSizeMB = 2;
    if (this.file.size > maxSizeMB * 1024 * 1024) {
      this.messageService.add({
        severity: 'error',
        summary: 'Imagem muito grande',
        detail: `A imagem deve ter no máximo ${maxSizeMB}MB.`,
        life: 3000,
      });
      return;
    }

    const isImage = this.file.type.startsWith('image/');
    if (!isImage) {
      this.messageService.add({
        severity: 'error',
        summary: 'Formato inválido',
        detail: 'Apenas imagens são permitidas.',
        life: 3000,
      });
      return;
    }

    if (this.file) {
      this.selectedFile = this.file;
      this.representanteForm.patchValue({ Foto: this.file });

      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result as string;
      };
      reader.readAsDataURL(this.file);
    }
    /*this.file = event.currentFiles[0];
    console.log(this.file);
    const reader = new FileReader();
    reader.onload = () => {
      this.imagePreview = reader.result; // Store Base64 URL
    };
    reader.readAsDataURL(this.file);*/
  }

  save() {
    if (this.representanteForm.valid) {
      const value = this.representanteForm.getRawValue();

      if (!this.isEditMode) {
        delete (value as any).id;
      }

      if (value.Foto) {
        delete (value as any)?.Foto;
      }

      const formData = new FormData();
      formData.append('payload', JSON.stringify(value));
      if (this.selectedFile) {
        formData.append('file', this.selectedFile);
      }

      this.ref.close(formData);
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Formulário inválido',
        detail:
          'Por favor, preencha todos os campos obrigatórios corretamente.',
        life: 3000,
      });
    }
  }

  cancel() {
    this.ref.close();
  }

  searchDocumentNumber() {
    const biVal = this.representanteForm.controls['bi']?.value;
    if (!biVal) return;

    this.authService.consultarBi(biVal as string).subscribe((result) => {
      const isSuccess =
        result?.retorno?.codigo == 200 ||
        result?.data?.code == 200 ||
        result?.data?.codigo == 200;
      if (isSuccess) {
        const personData = result.data?.data || result.data || {};
        const firstName = personData.first_name || personData.nome || '';
        const lastName = personData.last_name || personData.sobrenome || '';
        const nomeCompleto = `${firstName} ${lastName}`.trim();

        const patchValues: any = {};
        if (nomeCompleto) {
          patchValues.nome = nomeCompleto;
        }
        if (personData.numeroContacto || personData.telefone) {
          patchValues.telefone =
            personData.numeroContacto || personData.telefone;
        }
        if (personData.email) {
          patchValues.emailRepresentante = personData.email;
        }

        this.representanteForm.patchValue(patchValues);

        this.representanteForm.controls['telefone'].enable();
        this.representanteForm.controls['emailRepresentante'].enable();
      }
    });
  }
}
